<template>
    <v-modal :active="active" @close="$emit('close')">
        <div v-padding="2">
            <v-row>
                <v-col></v-col>
                <v-col xs="8">
                    <div v-margin.top="1" v-text-align.center>
                        <v-text type="subheadling">
                            Пользовательское соглашение
                        </v-text>
                    </div>
                </v-col>
                <v-col v-text-align.right>
                    <v-icon-button @click="$emit('close')">
                        clear
                    </v-icon-button>
                </v-col>
            </v-row>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    1. Термины и определения
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-text>
                    <strong>Сайт</strong> – совокупность размещенных в сети электронных документов (файлов), объединенных единой темой, дизайном и адресным пространством домена unirate24.ru Стартовая страница Сайта размещена в сети Интернет по адресу
                    <v-link target="_blank" to="http://unirate24.ru">
                        http://unirate24.ru
                    </v-link>
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-text>
                    <strong>Администрация сайта (Администрация)</strong> – Администрация сайта «unirate24.ru»
                    <v-link target="_blank" to="http://unirate24.ru">
                        http://unirate24.ru
                    </v-link> в лице технического директора, глав клиентского отдела и отдела технической поддержки клиентов, главного редактора.
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-text>
                    <strong>Пользователь Сайта (Пользователь)</strong> – лицо, прошедшее Процедуру регистрации, получившее индивидуальный логин и/или пароль, а также имеющее свой Профиль. Для целей Пользовательского соглашения под Пользователем понимается также лицо, которое не прошло Процедуру регистрации, но осуществляет доступ к Сайту и/или использует и/или использовало его. Любое лицо, осуществляющее доступ к Сайту, этим автоматически подтверждает, что оно полностью согласно с положениями Пользовательского соглашения, и что в отношении него применимы требования, установленные Пользовательским соглашением.
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-text>
                    <strong>Контент пользователя (Контент)</strong> – любая текстовая и графическая информация Пользователя, оставляемая им на Сайте в виде статей, комментариев, жалоб, сообщений, Персональных Сообщений (ПС) другим Пользователям, постов и иных видах.
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    2. Основные аспекты
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-list number>
                    <v-list-item>
                        Настоящее Соглашение является публичной офертой Администрации сайта, и его условия обязательны для всех Пользователей.
                    </v-list-item>
                    <v-list-item>
                        Настоящее Соглашение представляет собой публичную оферту, в соответствии со ст. 435 ГК РФ. Согласие Пользователя с условиями настоящего Соглашения (акцептом) считается фактическое пользование Сайтом, его сервисами и результатами интеллектуальной деятельности размещенными на нем.
                    </v-list-item>
                    <v-list-item>
                        Для получения возможности пользования Сайтом необходимо ознакомиться и согласиться с текстом данного Соглашения. Если Пользователь начал пользоваться Сайтом, то это рассматривается как полное и безоговорочное согласие с текстом данного Соглашения.
                    </v-list-item>
                </v-list>
            </div>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    3. Регистрация пользователя
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-list number>
                    <v-list-item>
                        Регистрируясь на Сайте, Пользователь обязуется предоставить при регистрации актуальную, точную и полную информацию о себе или о своей компании, которая может быть запрошена от Пользователя регистрационными формами Сайта.
                    </v-list-item>
                    <v-list-item>
                        Пользователь соглашается с тем, что несет персональную ответственность (перед Администрацией и иными лицами) за любые действия, совершаемые третьими лицами посредством его учетной записи, а также за любые последствия, которые могло повлечь или повлекло подобное ее использование.
                    </v-list-item>
                    <v-list-item>
                        Пользователь обязуется принимать необходимые меры для обеспечения сохранности своего логина и пароля для доступа в Аккаунт.
                    </v-list-item>
                    <v-list-item>
                        Оставляя свои контактные данные, Пользователь дает свое безусловное согласие на хранение, обработку и использование своих контактных данных, в том числе и для передачи их лицам, которые могут помочь в разрешении описанной Пользователем проблемы (по их запросу), а именно: официальным представителям компании-ответчика, представителям Государственных структур, представителям Средств Массовой Информации.
                    </v-list-item>
                    <v-list-item>
                        Оставляя свои контактные данные, Пользователь дает свое безусловное согласие на получение писем от Администрации на e-mail Пользователя, на звонки Администрации на телефоны Пользователя с целью контроля качества услуг Администрацией, предложения новых услуг Администрацией Пользователю, информирования Пользователя о работе Сайта Администрацией.
                    </v-list-item>
                </v-list>
            </div>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    4. Обязанности Пользователя
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-text>
                    Пользователь обязуется:
                </v-text>
                <v-list number>
                    <v-list-item>
                        Не регистрировать Аккаунт от имени лица, которым не является (фальшивый Аккаунт), или действовать от имени организации, компании, марки, юридического или физического лица и пр., чьи интересы он не уполномочен представлять;
                    </v-list-item>
                    <v-list-item>
                        Не совершать никаких действий, имеющих цель получить доступ к Сайту путем направления на серверы такого количества запросов в течение установленной единицы времени, которое реальный Пользователь не сможет направить в такой же период посредством использования общедоступного стандартного веб-браузера;
                    </v-list-item>
                    <v-list-item>
                        Не распространять, не изменять фрагмент или фрагменты Сайта, не вмешиваться в его работу, нарушая ее, любыми средствами и способами;
                    </v-list-item>
                    <v-list-item>
                        Не получать доступ к Сайту или к размещенному на Сайте Контенту посредством какой-либо технологии или средств (программы, скрипты и проч.), не предусмотренных или не расположенных специально на Сайте;
                    </v-list-item>
                    <v-list-item>
                        Не использовать Сайт в любых коммерческих целях без предварительного письменного разрешения Администрации;
                    </v-list-item>
                    <v-list-item>
                        Не запрашивать у других Пользователей пароли и другую идентификационную информацию для ее неправомерного использования, а также в коммерческих или корыстных целях;
                    </v-list-item>
                    <v-list-item>
                        Не размещать на Сайте домашние адреса, номера телефонов, адреса электронной почты, паспортные данные и прочую личную информацию других пользователей или любых третьих лиц без их личного согласия;
                    </v-list-item>
                    <v-list-item>
                        Не размещать любую информацию, нарушающую исключительные права пользователей или третьих лиц на объекты интеллектуальной собственности;
                    </v-list-item>
                    <v-list-item>
                        Не преследовать иных Пользователей и не вступать в контакт с ними в случае выражения ими нежелания контакта с Пользователем;
                    </v-list-item>
                    <v-list-item>
                        Администрация оставляет за собой право блокировать или удалять любой контент, неудовлетворяющий данному Соглашению.
                    </v-list-item>
                </v-list>
            </div>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    5. Содержание сайта и права на него
                </v-text>
            </div>
            <div v-margin.bottom="1">
                <v-list number>
                    <v-list-item>
                        Все объекты, размещенные на Сайте, в том числе элементы дизайна, текст, графические изображения, иллюстрации, видео, скрипты и другие объекты и их подборки, являются объектами исключительных прав Администрации, Пользователей и других правообладателей, все права на эти объекты защищены;
                    </v-list-item>
                    <v-list-item>
                        Без предварительного письменного согласия Администрации или лица, передавшего Администрации права на Контент, Пользователь и/или третьи лица не имеют права распоряжаться любым способом элементами содержания Сайта и/или Контента;
                    </v-list-item>
                    <v-list-item>
                        Размещая свой Контент на Сайте Пользователь предоставляет:
                        <v-list>
                            <v-list-item>
                                Администрации - международную, неисключительную, бесплатную и передаваемую лицензию (с правом сублицензирования) на публичный показ, исполнение, воспроизведение, распространение, создание производных произведений, запись, сообщение в эфир, по кабелю, прокат, импорт, перевод, переработку и доведение до всеобщего сведения в рамках работы Сайта, в том числе для целей коммерческой деятельности Администрации, включая, среди прочего, продвижение и организацию Сайта полностью или частично (и производных его произведений) в любых медийных форматах и по любым средствам продвижения, в том числе в рекламно-информационных материалах Администрации;
                            </v-list-item>
                            <v-list-item>
                                Другим Пользователям сайта - международную, неисключительную, бесплатную лицензию на доступ к Контенту через Сайт и на воспроизведение, распространение, создание производных произведений, демонстрацию:
                                <v-list>
                                    <v-list-item>
                                        Вышеуказанные лицензии, предоставленные Пользователем, являются бессрочными и безотзывными;
                                    </v-list-item>
                                    <v-list-item>
                                        Кроме своего собственного Контента, Пользователь не вправе загружать или иным образом доводить до всеобщего сведения (публиковать на Сайте) Контент других сайтов, баз данных и прочих объектов исключительных прав при отсутствии явным образом выраженного согласия правообладателя на такие действия;
                                    </v-list-item>
                                    <v-list-item>
                                        Законный правообладатель Контента, обоснованно считающий, что его права и интересы нарушены действиями Пользователя или третьих лиц в связи с размещением на Сайте такого контента, направляет подробное уведомление на Сайт через раздел «Контакты» на Сайте. В случае, если будут предоставлены все необходимые доказательства прав на Контент – такой Контент будет удален с Сайта.
                                    </v-list-item>
                                </v-list>
                            </v-list-item>
                        </v-list>
                    </v-list-item>
                </v-list>
            </div>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    6. Взаимодействие с другими сайтами
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-list number>
                    <v-list-item>
                        Сайт может содержать гиперссылки на другие сайты, которые не находятся в собственности или связаны с Администрацией;
                    </v-list-item>
                    <v-list-item>
                        Администрация не контролирует и не берет на себя никакой ответственности за содержание таких сайтов.
                    </v-list-item>
                </v-list>
            </div>
    
            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    7. Изменения настоящего договора
                </v-text>
            </div>
    
            <div v-margin.bottom="1">
                <v-list number>
                    <v-list-item>
                        Администрация может в одностороннем порядке изменять положения настоящего Соглашения. Обновленная версия настоящего Соглашения публикуются по следующему адресу:
                        <v-link target="_blank" to="http://unirate24.ru">
                            http://unirate24.ru
                        </v-link>, который Пользователь обязан регулярно проверять;
                    </v-list-item>
                    <v-list-item>
                        Если Пользователь продолжает пользоваться Сайтом после даты внесения изменений в положения настоящего Соглашения, то это рассматривается как понимание, согласие и принятие в полном объеме таких изменений.
                    </v-list-item>
                </v-list>
            </div>

            <div v-margin.bottom="1">
                <v-text type="subheadling" bold>
                    8. Ответственность сторон
                </v-text>
            </div>

            <div>
                <v-list number>
                    <v-list-item>
                        За неисполнение или ненадлежащее исполнение принятых на себя обязательств Стороны несут ответственность согласно действующему законодательству РФ и настоящему Соглашению;
                    </v-list-item>
                    <v-list-item>
                        Пользователь соглашается с тем, что он единолично и в полном объеме несет ответственность за любое нарушение своих обязательств и условий настоящего Соглашения, за последствия любого такого нарушения, включая любой ущерб;
                    </v-list-item>
                    <v-list-item>
                        Администрация не несет никакой ответственности перед Пользователем или какими-либо третьими лицами за любые нарушения Пользователями данного Соглашения;
                    </v-list-item>
                    <v-list-item>
                        Пользователь принимает и соглашается с тем, что Администрация не несет никакой ответственности за любые убытки, которые возникли у Пользователя в результате использования Сайта или любой информации, расположенной на Сайте (в том числе Контента других Пользователей).
                    </v-list-item>
                </v-list>
            </div>
        </div>
    </v-modal>
</template>
<script>
export default {
    name: 'modal-user-agreement',
    props: {
        active: Boolean,
    },
}
</script>



// WEBPACK FOOTER //
// ModalUserAgreement.vue?680760e4